import platformPub from '@/i18n/langs/platform/platform.en';
const en = {
    ...platformPub
};
export default en;



// WEBPACK FOOTER //
// ./src/i18n/langs/en.js